require('@atlassian/atlassianeditor/dist/atlassian-editor.min.js');
